import { getField, updateField } from 'vuex-map-fields'
import http from './../utils/http'
import * as Utils from '@/utils/utils'

export default {
  namespaced: true,
  state: {
    items: [],
    itemsLoading: false
  },
  mutations: {
    updateField,
    // Items
    setItems (state: any, payload: any) {
      state.items = payload
    },
    setItemsLoading (state: any, payload: any) {
      state.itemsLoading = payload
    },
    addToItems (state: any, payload: any) {
      state.items = state.items.concat(payload)
    }
  },
  actions: {
    fetchItems (context: any) {
      context.commit('setItemsLoading', true)

      new Promise((resolve, reject) => {
        Utils.getAllData('/category', ['associations[parent][]', 'sort=level'], 100, resolve, reject)
      })
        .then(response => {
          context.commit('setItemsLoading', false)
        })
        .catch(error => {
          console.error(error)
        })
    }
  },
  getters: {
    getField,
    getItemsByLevel: (state: any) => (level: any) => {
      let result = state.items.filter((obj: any) => {
        return obj.level === level
      })
      return result
    },
    getItemsByParentId: (state: any) => (parentId: any) => {
      let result = state.items.filter((obj: any) => {
        return obj.parentId === parentId
      })
      return result
    }
  }
}
